<template>
  <div class="rightAll">
    <div class="rightAll-form">
      <el-form :inline="true" :model="formInline" class="demo-form-inline">
        <el-form-item :label="$t('common.num')">
          <el-select
            v-model="formInline.selectCarType"
            style="width: 120px"
            :placeholder="$t('common.choseTip')"
            class="selectStyle"
          >
            <el-option
              v-for="item in optionsInput"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
          <el-input
            size="mini"
            v-model="formInline.selectCarValue"
            :placeholder="$t('common.searchTip')"
            style="width: 150px"
            class="inputStyle"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('TopBar.happenTime')">
          <el-date-picker
            v-model="formInline.MaintainTime"
            type="datetimerange"
            style="width: 220px"
            size="mini"
            value-format="yyyy-MM-dd HH:mm:ss"
            range-separator
            :start-placeholder="$t('common.choseTime')"
            end-placeholder
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            size="mini"
            type="primary"
            @click="onSearch"
            class="btn-chaxun"
            >{{ $t("common.btn.search") }}</el-button
          >
          <el-button size="mini" @click="onClear" class="btn-del">{{
            $t("common.btn.cancel")
          }}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="rightAll-btn">
      <el-button v-if="isPrimaryKey('REPAIRFORM_REMINDER')" type="text" @click="down">{{
        $t("common.btn.download")
      }}</el-button>
    </div>
    <i-table
      :list="list"
      :height="height"
      ref="carTable"
      @handleSelectionChange="handleSelectionChange"
      :options="option"
      :columns="columns"
      :operates="operates"
    ></i-table>
    <IPagination ref="page" @PageFun="changeSize"></IPagination>
  </div>
</template>

<script>
import Closed from "./Closed.js";
export default Closed;
</script>

<style lang="less" scoped>
@import "../../../../assets/styles/Style.less";
</style>
